import { Avatar, Stack, Typography } from '@mui/material';
import { IFamilyMembers } from 'API/personalDetails';
import { format } from 'date-fns';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { FemaleIcon, MaleIcon } from 'Images';
export interface IFamilyCard {
  familyMember: IFamilyMembers;
}

export const FamilyCard = ({ familyMember }: IFamilyCard) => {
  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(Dictionary, DICTIONARY.PersonalDetails);

  return (
    <Stack
      padding={'16px'}
      gap={'12px'}
      border={'1px solid'}
      borderColor={isDesktop ? 'purple2.shade_200' : 'purple2.shade_100'}
      borderRadius={'12px'}
      bgcolor={'purple2.shade_50'}
    >
      <Stack
        direction={'row'}
        gap={isDesktop ? '20px' : '12px'}
        width={'auto'}
        alignSelf={'flex-start'}
      >
        <Stack alignItems={'center'} width={'auto'}>
          <Avatar
            alt={''}
            src={familyMember.gender === 1 ? MaleIcon : FemaleIcon}
            sx={{ width: '28px', height: '28px' }}
          />
          <Typography variant={'body6'} whiteSpace={'nowrap'}>
            {familyMember.gender === 1
              ? dictionary.familyStatus.male
              : dictionary.familyStatus.female}
            {familyMember.relation === 2 &&
              ' ' + dictionary.familyStatus.couple}
          </Typography>
        </Stack>
        <Stack gap={isDesktop ? '4px' : '2px'}>
          <Typography variant={'body4'}>
            {familyMember.firstName + ' ' + familyMember.lastName}
          </Typography>
          <Typography variant={'body4'}>{familyMember.idNumber}</Typography>
        </Stack>
      </Stack>
      {familyMember.birthDate && (
        <Typography
          variant={'body6'}
          width={isDesktop ? '125px' : '109px'}
          textAlign={'right'}
        >
          {format(new Date(familyMember.birthDate), 'dd.MM.yyyy')}
        </Typography>
      )}
    </Stack>
  );
};
